import { RichText } from "prismic-reactjs";
import React from "react";
import { Link } from "react-router-dom";
import { linkResolver } from "../../../../@prismic/prismic-config";
import NoPhoto from "../../../../images/no-photo.svg";
import * as S from "./styles";
export var ProductBenefit = function ProductBenefit(_ref) {
  var label = _ref.label,
      primary = _ref.primary;

  if (!primary) {
    return null;
  }

  var image = primary.image,
      title = primary.title,
      text = primary.text,
      link = primary.link,
      link_label = primary.link_label;
  var isCta = label === "cta";
  return isCta ? React.createElement(S.CtaWrapper, {
    style: {
      backgroundImage: "url(".concat(image.url || NoPhoto, ")")
    }
  }, React.createElement(RichText, {
    render: title
  }), React.createElement(RichText, {
    render: text
  }), React.createElement(Link, {
    to: linkResolver(link)
  }, link_label), React.createElement(S.Overlay, null)) : React.createElement(S.Wrapper, null, React.createElement(S.Image, {
    src: image.url || NoPhoto
  }), React.createElement(RichText, {
    render: title
  }), React.createElement(RichText, {
    render: text
  }));
};